import React, {useEffect, useState} from "react";
import './Login.scss'
import BaseButton from "../BaseButton/BaseButton";
import BottomSheet from "../BottomSheet/BottomSheet";
import send from '../../Assets/Icons/send.svg'
import BaseInput from "../BaseInput/BaseInput";
import axios from "axios";
import {setUser} from "../../store/actions";
import {useDispatch} from "react-redux";
import Success from "../Success/Success";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../Loader/Loader";
import Error from "../Error/Error";
import {useError} from "../../hooks/useError";
import {useTranslation} from "react-i18next";
import {getCurrentLanguage} from "../../i18n/i18n";

interface Props {
    onValidate: () => void
    show: boolean
    onClose: () => void
}

const Login: React.FC<Props> = ({onValidate, show, onClose}: Props) => {
    const {t} = useTranslation(['login', 'common'])
    const dispatch = useDispatch()
    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailError] = useState<string | undefined>(undefined)
    const [mdp, setMdp] = useState<string>('')
    const [showSendMdpConfirm, setShowSendMdpConfirm] = useState<boolean>(false)

    const loader = useLoader()
    const error = useError()

    useEffect(() => {
        setEmailError(undefined)
    }, [email])

    const handleBtn = () => {
        if(email.length > 0 && mdp.length > 0) {
            loader.show()
            axios.post(`${process.env.REACT_APP_BART_URL}/users/login`, {email, mdp})
                .then(res => {
                    dispatch(setUser(res.data))
                    onValidate()
                })
                .catch(() => {
                    error.open(t('login:errors.wrongCredentials'))
                })
                .finally(loader.hide)
        }
    }

    const handleMdpClick = () => {
        if(email.length === 0) {
            setEmailError(t('login:errors.emailRequired'))
        } else {
            const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            if(regex.test(email)){
                loader.show()
                void axios.get(`${process.env.REACT_APP_BART_URL}/users/exist/${email}`)
                    .then((response) => {
                        loader.hide()
                        if(response.data) {
                            void axios.post(`${process.env.REACT_APP_BART_URL}/emails/send_reset_password_email/${email}?lang=${getCurrentLanguage()}`)
                            setShowSendMdpConfirm(true)
                        } else {
                            setEmailError(t('login:errors.emailNotFound'))
                        }
                    })

            } else {
                setEmailError(t('login:errors.emailInvalid'))
            }
        }
    }

    return (
        <>
            {
                error.visible ? (
                    <Error show={error.visible} close={error.close} title={t('common:errors.generic')} subTitle={error.message} />
                ) : (
                    <>
                        {
                            !showSendMdpConfirm ? (
                                <BottomSheet show={show} close={onClose}>
                                    <div className="login">
                                        <h1 className="login--title">{t('login:title')}</h1>
                                        <p className="login--text">{t('login:subtitle')}</p>
                                        <BaseInput title={t('login:emailLabel')} value={email} type={"email"} onChange={setEmail} className="login--input" errorTxt={emailError} />
                                        <BaseInput
                                            title={t('login:passwordLabel')}
                                            helpTxt={t('login:passwordHelp')}
                                            onChange={setMdp}
                                            value={mdp}
                                            type={"password"}
                                            className="login--input"
                                        />
                                        <p className="login--mdpOublie" onClick={handleMdpClick}>{t('login:forgotPassword')}</p>
                                        <BaseButton onClick={handleBtn} text={t('login:submit')} className="login--btn"/>
                                    </div>
                                </BottomSheet>
                            ) : (
                                <Success
                                    show={showSendMdpConfirm}
                                    close={() => setShowSendMdpConfirm(false)}
                                    title={email}
                                    subTitle={t('login:resetEmailSent')}
                                    icone={send}
                                    btnTxt={t('common:actions.close')}
                                />
                            )
                        }
                        <Loader visible={loader.visible} />
                    </>
                )
            }
        </>
    )
}

export default Login
